/* unplugin-vue-components disabled */import script from "./RealtimeTest.vue?vue&type=script&setup=true&lang=js"
export * from "./RealtimeTest.vue?vue&type=script&setup=true&lang=js"

import "./RealtimeTest.vue?vue&type=style&index=0&id=38122466&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@5.8.3__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38122466"]])

export default __exports__